// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientsTypeahead_HouseholdFragment = { __typename?: 'Household', id: string, displayName: string, primaryRelationshipOwner: { __typename?: 'User', id: string, displayName: string } };

export type GetClientsMultipleQueryVariables = Types.Exact<{
  optionsLike?: Types.InputMaybe<Types.HouseholdWhereInput>;
  selectedOptionsLike?: Types.InputMaybe<Types.HouseholdWhereInput>;
  first: Types.Scalars['Int']['input'];
  query: Types.Scalars['String']['input'];
}>;


export type GetClientsMultipleQuery = { __typename?: 'Query', queryData: { __typename?: 'HouseholdConnection', totalCount: number, edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & ClientsTypeahead_HouseholdFragment
      ) | null } | null> | null }, selectedData: { __typename?: 'HouseholdConnection', totalCount: number, edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & ClientsTypeahead_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetClientsMultiple: 'GetClientsMultiple' as const
  },
  Fragment: {
    ClientsTypeahead_Household: 'ClientsTypeahead_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientsTypeahead_HouseholdFragmentDoc = gql`
    fragment ClientsTypeahead_Household on Household {
  id
  displayName
  primaryRelationshipOwner {
    id
    displayName
  }
}
    `;
export const GetClientsMultipleDocument = gql`
    query GetClientsMultiple($optionsLike: HouseholdWhereInput, $selectedOptionsLike: HouseholdWhereInput, $first: Int!, $query: String!) {
  queryData: searchHouseholds(
    where: $optionsLike
    first: $first
    orderBy: [{direction: ASC, field: sortable_last_name}]
    query: $query
  ) {
    totalCount
    edges {
      node {
        ...ClientsTypeahead_Household
      }
    }
  }
  selectedData: households(where: $selectedOptionsLike) {
    totalCount
    edges {
      node {
        ...ClientsTypeahead_Household
      }
    }
  }
}
    ${ClientsTypeahead_HouseholdFragmentDoc}`;

/**
 * __useGetClientsMultipleQuery__
 *
 * To run a query within a React component, call `useGetClientsMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsMultipleQuery({
 *   variables: {
 *      optionsLike: // value for 'optionsLike'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetClientsMultipleQuery(baseOptions: Apollo.QueryHookOptions<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>(GetClientsMultipleDocument, withFetchPolicyContext(options));
      }
export function useGetClientsMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>(GetClientsMultipleDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetClientsMultipleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>(GetClientsMultipleDocument, withFetchPolicyContext(options));
        }
export type GetClientsMultipleQueryHookResult = ReturnType<typeof useGetClientsMultipleQuery>;
export type GetClientsMultipleLazyQueryHookResult = ReturnType<typeof useGetClientsMultipleLazyQuery>;
export type GetClientsMultipleSuspenseQueryHookResult = ReturnType<typeof useGetClientsMultipleSuspenseQuery>;
export type GetClientsMultipleQueryResult = Apollo.QueryResult<GetClientsMultipleQuery, GetClientsMultipleQueryVariables>;